import useDidMount from '~/client/hooks/lifecycle/useDidMount';
import {
  useMyLoyaltyStatusSidebarQuery,
  MyLoyaltyStatusSidebarQuery,
} from './MyLoyaltyStatusSidebar.generated';
import {
  MyLoyaltyStatusSidebarSubscriptionDocument,
  MyLoyaltyStatusSidebarSubscription,
} from './MyLoyaltyStatusSidebarSubscription.generated';

type Props = {
  skip?: boolean;
};

const useMyLoyaltyStatusSidebar = (props?: Props) => {
  const skip = props?.skip;
  const { data, loading, subscribeToMore } = useMyLoyaltyStatusSidebarQuery({
    skip,
  });

  useDidMount(() => {
    subscribeToMore({
      document: MyLoyaltyStatusSidebarSubscriptionDocument,
      variables: { input: {} },
      updateQuery: (prev, { subscriptionData }) => {
        const newData =
          subscriptionData.data as MyLoyaltyStatusSidebarSubscription;
        if (!newData) {
          return prev;
        }
        const newMyStatus = newData?.loyaltyPublicMyStatusUpdated?.myStatus;
        const newCurrentTier =
          newData?.loyaltyPublicMyStatusUpdated?.myStatus?.currentTier;
        const newNextMilestone =
          newData?.loyaltyPublicMyStatusUpdated?.myStatus?.nextMilestone;

        const newResult = {
          loyaltyPublic: {
            myStatus: {
              ...newMyStatus,
              currentTier: {
                ...newCurrentTier,
              },
              nextMilestone: {
                ...newNextMilestone,
              },
            },
          },
        };
        return newResult as MyLoyaltyStatusSidebarQuery;
      },
    });
  });

  const myStatus = data?.loyaltyPublic?.myStatus ?? {};
  return { loading, myStatus };
};

export default useMyLoyaltyStatusSidebar;
